module.exports = __webpack_public_path__ + "static/media/Logo__FloridaPanthers.7b4b593a.svg";